import React from 'react';
import { useSelector } from 'react-redux';
import { getLocalString, localNames } from 'utils/localisation.service';

const UploadTitle = (fileCode) => {
  const locales = useSelector(state => state.forms?.localeStrings);
  return (
    <div className="custom-drag__title">
      {fileCode == "businessPlanFile" || fileCode == "eligibilityFile" ? getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_DRAGANDDROP2)
      : getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_DRAGANDDROP)}
    </div>
  );
};

export default UploadTitle;
